class MobileMenu {
  constructor() {
    this.menu = document.querySelector(".site-header__menu");
    this.openButton = document.querySelector(".site-header__menu-trigger");
    this.menuItems = document.querySelectorAll(".site-header__menu .menu-item a");
    this.events();
  }

  events() {
    this.openButton.addEventListener("click", () => this.toggleMenu());
    this.menuItems.forEach(item => {
      item.addEventListener("click", () => this.closeMenu());
    });
  }

  toggleMenu() {
    this.openButton.classList.toggle("fa-bars");
    this.openButton.classList.toggle("fa-times");
    this.menu.classList.toggle("site-header__menu--active");
  }

  closeMenu() {
    if (this.menu.classList.contains("site-header__menu--active") && window.location.href.includes("shop")) {
      this.toggleMenu();
    }
  }
}

export default MobileMenu;
